import { Box } from '@material-ui/core';
import React from 'react';
import { translate } from '../../../../../common/intl';
import { Button } from '../../../../components/forms/fields-next';
import KendoDataGridShell, { KendoDataGridShellColumn } from '../../../../components/KendoDataGrid/KendoDataGridShell';
import useStyles from './styles';

interface PlaceholderProps {
  columns: KendoDataGridShellColumn[]
  canAdd?: boolean
  onAdd?: () => void
}

const Placeholder: React.FC<PlaceholderProps> = ({
  columns,
  canAdd,
  onAdd,
}) => {
  const classes = useStyles({});

  return (
    <Box data-cy="lhr-equipment-table">
      <KendoDataGridShell
        columns={columns}
        withBottomButton={canAdd}
        dataCy="equipment-grid-empty"
      />
      {canAdd && (
        <Button
          fullWidth
          attached
          kind="add"
          className={classes.bottomAddButtom}
          data-cy="add-equipment"
          onClick={onAdd}
        >
          {translate('form.builder.add.item')}
        </Button>
      )}
    </Box>
  );
};

export default Placeholder;
